import { connect } from 'react-redux';

import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { originalEmailActions } from '../actions/originalEmail';
import OriginalEmailModal from '../components/OriginalEmailModal';

const mapStateToProps = (state) => {
  return {
    originalEmail: state.originalEmail,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    originalEmailCloseModal: bindActionToPromise(
      dispatch,
      originalEmailActions.originalEmailCloseModal,
    ),
    originalEmailClosePrinterFriendlyModal: bindActionToPromise(
      dispatch,
      originalEmailActions.originalEmailClosePrinterFriendlyModal,
    ),
    originalEmailHtmlGetByType: bindActionToPromise(
      dispatch,
      originalEmailActions.originalEmailHtmlGetByType,
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OriginalEmailModal);
